import { jsx as _jsx } from "react/jsx-runtime";
import { formatPrice } from './formatPrice.js';
import styles from './Price.module.css';
/** Affiche un prix en Plex Mono `tabular-nums`, formaté selon la langue (2.4, D15). */
export function Price({ cents, lang = 'fr', currency = 'EUR', size = 'md', className, ...rest }) {
    const classes = [styles.price, size === 'lg' ? styles.lg : '', className]
        .filter(Boolean)
        .join(' ');
    return (_jsx("span", { className: classes, lang: lang, ...rest, children: formatPrice(cents, lang, currency) }));
}
//# sourceMappingURL=Price.js.map